import React from 'react';
import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
} from "../../store/actions";
import { message } from 'antd';

import moment from 'moment';

import Config from '../../Config';
import { Helmet } from "react-helmet";
import queryString from 'query-string';

import '../../assets/laporan.css';


const configClass = {
	title: 'LAPORAN HARIAN PENGGUNAAN NOTICE',
	apiUrl: {
		preview: 'laporan/api/notice/penggunaan-rusak/',
	},
}

class LapPenggunaanNoticeRusakPrint extends React.Component {
	config;

	constructor(props) {
		super(props);
		this.config = new Config();
		this.state = {
			loading: false,
			data: null,
			err: false,
		}
	}

	componentDidMount() {
		var uri_params = "";
		const uri_string = queryString.parse(this.props.location.search);
		for (var key in uri_string) {
			uri_params += (uri_params === "" ? "?" : "&") + key + "=" + uri_string[key];
		}
		this.preview(uri_params);
	}

	async preview(uri_params) {
		message.loading({ content: 'Menampilkan laporan...', duration: 0, key: 'toast' });
		this.setState({ loading: true, err: false, data: null });

		this.props.ajaxViewHandler('get', configClass.apiUrl.preview + uri_params)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					message.destroy();
					this.setState({ loading: false, data: data, err: false });
					setTimeout(() => window.print(), 1300);
				} else {
					this.setState({ loading: false, data: null, err: true });
					message.error({ content: 'error get laporan', duration: 2, key: 'toast' });
				}
			}).catch(() => {
				this.setState({ loading: false, data: null, err: true });
				message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	fmtTanggal() {
		const { data } = this.state;
		if (!data) return '-';
		if (data.tanggal_sampai) {
			return `${data.tanggal_mulai} s.d. ${data.tanggal_sampai}`;
		}
		return data.tanggal_mulai || '-';
	}

	render() {
		const { data } = this.state;
		const rekap = data?.rekap || { terpakai: 0, batal: 0, rusak: 0, jumlah: 0 };
		const ttd = data?.ttd || {};
		const kabupatenNama = (data?.kabupaten_nama || '-').toUpperCase();
		const uptNama = (data?.upt_nama || '-').toUpperCase();

		const globalCount = {};
		if (data) {
			data.data.forEach(g => g.nomor_notice_terpakai.forEach(n => {
				globalCount[n.nomor_notice] = (globalCount[n.nomor_notice] || 0) + 1;
			}));
		}

		return (
			<>
				<Helmet>
					<title>{configClass.title}</title>
				</Helmet>
				<div className="kertas-laporan">

					{/* HEADER */}
					<div style={{ textAlign: 'center', marginBottom: 6 }}>
						<div style={{ fontSize: 13, fontWeight: 'bold', textTransform: 'uppercase' }}>
							BADAN PENDAPATAN DAERAH
						</div>
						<div style={{ fontSize: 13, fontWeight: 'bold', textTransform: 'uppercase' }}>
							SAMSAT {kabupatenNama}
						</div>
						<div style={{ fontSize: 14, fontWeight: 'bold', textTransform: 'uppercase', marginTop: 4, textDecoration: 'underline' }}>
							LAPORAN HARIAN PENGGUNAAN NOTICE
						</div>
					</div>

					{/* INFO */}
					<table style={{ marginBottom: 8, fontSize: 12 }}>
						<tbody>
							<tr>
								<td style={{ width: 100 }}>SAMSAT</td>
								<td style={{ paddingRight: 8 }}>:</td>
								<td>{uptNama}</td>
							</tr>
							<tr>
								<td>TANGGAL</td>
								<td>:</td>
								<td>{this.fmtTanggal()}</td>
							</tr>
						</tbody>
					</table>

					{/* TABLE */}
					{data != null && data.data.length > 0 && (
						<table className="laporan-table" border="1" cellPadding="4" style={{ width: '100%', fontSize: 11 }}>
							<thead>
								<tr>
									<th rowSpan={2}>No.</th>
									<th rowSpan={2}>Nomor Kendaraan</th>
									<th rowSpan={2}>Tgl Penetapan</th>
									<th rowSpan={2}>Masa Pajak</th>
									<th colSpan={2}>Nomor Notice</th>
									<th rowSpan={2}>Keterangan</th>
									<th rowSpan={2}>Jumlah</th>
								</tr>
								<tr>
									<th>Terpakai</th>
									<th>Batal/Rusak</th>
								</tr>
							</thead>
							<tbody>
								{data.data.map((g, gi) => {
									const batalSet = new Set(g.batal_rusak.map(k => k.nomor_notice));
									return (
										<tr key={gi}>
											<td className="teks-tengah">{gi + 1}</td>
											<td className="teks-tengah">{g.nomor_polisi}</td>
											<td className="teks-tengah">{g.tgl_penetapan}</td>
											<td className="teks-tengah">{g.masa_pajak}</td>
											<td className="teks-tengah">
												{g.nomor_notice_terpakai.length === 0 ? '-' : g.nomor_notice_terpakai.map((n, ni) => {
													const isRed = n.rusak || batalSet.has(n.nomor_notice) || globalCount[n.nomor_notice] > 1;
													return (
														<div key={ni} style={isRed ? { color: 'red', fontWeight: 600 } : undefined}>
															{n.nomor_notice}
														</div>
													);
												})}
											</td>
											<td className="teks-tengah">
												{g.batal_rusak.length === 0 ? '-' : g.batal_rusak.map((k, ki) => (
													<div key={ki}>{k.nomor_notice}</div>
												))}
											</td>
											<td className="teks-tengah">
												{g.batal_rusak.length === 0 ? '-' : g.batal_rusak.map((k, ki) => (
													<div key={ki}>{k.keterangan}</div>
												))}
											</td>
											<td className="teks-kanan">
												{g.nomor_notice_terpakai.filter(n => n.jumlah > 0).map((n, ni) => (
													<div key={'t' + ni}>{Number(n.jumlah).toLocaleString('id')}</div>
												))}
												{g.batal_rusak.map((k, ki) => (
													<div key={'b' + ki}>{Number(k.jumlah || 0).toLocaleString('id')}</div>
												))}
												{g.nomor_notice_terpakai.filter(n => n.jumlah > 0).length === 0 && g.batal_rusak.length === 0 && '-'}
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					)}

					{data != null && data.data.length === 0 && (
						<div className="teks-tengah" style={{ padding: 20 }}>Tidak ada data pada periode/filter ini.</div>
					)}

					{/* FOOTER */}
					{data != null && (
						<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16, fontSize: 12 }}>

							{/* REKAPITULASI */}
							<div style={{ minWidth: 240 }}>
								<div style={{ fontWeight: 'bold', marginBottom: 4, textDecoration: 'underline' }}>REKAPITULASI</div>
								<table>
									<tbody>
										<tr>
											<td style={{ paddingRight: 4 }}>1. TERPAKAI</td>
											<td style={{ paddingRight: 4 }}>:</td>
											<td style={{ textAlign: 'right', paddingRight: 8 }}>{rekap.terpakai}</td>
											<td>Lembar</td>
										</tr>
										<tr>
											<td>2. RUSAK</td>
											<td>:</td>
											<td style={{ textAlign: 'right', paddingRight: 8 }}>{rekap.rusak}</td>
											<td>Lembar</td>
										</tr>
										<tr>
											<td style={{ borderTop: '1px solid #000', fontWeight: 'bold' }}>JUMLAH</td>
											<td style={{ borderTop: '1px solid #000', fontWeight: 'bold' }}>:</td>
											<td style={{ borderTop: '1px solid #000', textAlign: 'right', paddingRight: 8, fontWeight: 'bold' }}>{rekap.jumlah}</td>
											<td style={{ borderTop: '1px solid #000', fontWeight: 'bold' }}>Lembar</td>
										</tr>
										<tr><td colSpan={4} style={{ paddingTop: 5 }}></td></tr>
										<tr>
											<td style={{ paddingRight: 4, color: '#555' }}>BATAL TRANSAKSI</td>
											<td style={{ paddingRight: 4, color: '#555' }}>:</td>
											<td style={{ textAlign: 'right', paddingRight: 8, color: '#555' }}>{rekap.batal}</td>
											<td style={{ color: '#555' }}>Transaksi</td>
										</tr>
									</tbody>
								</table>
								{/* <div style={{ fontSize: 9, color: '#777', marginTop: 4 }}>*) Nomor notice dapat digunakan kembali</div> */}
							</div>

							{/* TANDA TANGAN */}
							{ttd.kanan && (
								<div style={{ textAlign: 'center', minWidth: 220 }}>
									<div>{kabupatenNama}, {moment().format('DD-MM-YYYY')}</div>
									<div style={{ fontWeight: 'bold', textTransform: 'uppercase', marginTop: 2 }}>
										{ttd.kanan.jabatan || 'PETUGAS PENETAPAN KENDARAAN'}
									</div>
									<div style={{ marginTop: 60 }}>
										<u style={{ fontWeight: 'bold' }}>{ttd.kanan.nama}</u>
									</div>
									<div>{ttd.kanan.nip}</div>
								</div>
							)}
						</div>
					)}

				</div>
			</>
		);
	}
}

const mapStateToProps = function (state) {
	return state.configReducers
}

export default connect(
	mapStateToProps,
	{
		initHandler,
		setConfig,
		ajaxViewHandler,
		ajaxHandler,
	}
)(LapPenggunaanNoticeRusakPrint);
